import Vue from 'vue'
import Router from 'vue-router'
import Failover from '@/components/Failover'
import Login from '@/components/Login'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Failover',
      component: Failover
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    }
  ],
  mode: 'history'
})

router.beforeEach((to, from, next) => {
  if (to.name !== 'Login' && !store.getters.isAuthenticated) {
    next('/login')
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js